import classNames from 'classnames';
import { t } from 'ttag';

import TopSellerIcon from '@svg/top-seller.svg';

import s from './TopSellerBadge.sss';

interface Props {
  className?: string,
}

export const TopSellerBadge: React.FC<Props> = ({
  className,
}) => (
  <div className={classNames(s.root, className)}>
    <TopSellerIcon
      className={s.icon}
      width="16"
      height="16"
    />
    <p className={s.label}>
      {t`Супер-продавець`}
    </p>
  </div>
);
